import React, { useEffect } from 'react';

import { useMobileViewport } from 'hooks/useMobileViewport';
import { useHistory } from 'react-router-dom';

import { ROOT_PATH } from 'constants/routeConstants';

import NotificationCenterWrapper from './components/Wrapper';
import NotificationCenterTabs from './components/Tabs';
import NotificationCenterContent from './components/Content';

export default function NotificationCenter() {
  const isMobile = useMobileViewport();
  const history = useHistory();

  useEffect(() => {
    if (isMobile) {
      history.push(ROOT_PATH);
    }
  }, [isMobile]);

  return (
    <NotificationCenterWrapper>
      <NotificationCenterTabs />
      <NotificationCenterContent />
    </NotificationCenterWrapper>
  );
}
